var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-builder',{model:{value:(_vm.ptw),callback:function ($$v) {_vm.ptw=$$v},expression:"ptw"}})
}
var staticRenderFns = []

export { render, staticRenderFns }